export {default} from './research.vue'